import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import UsersListComponent from '@app/components/manage-users/list';

const UsersPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTitle>{t('users.view')}</PageTitle>
      <UsersListComponent />
    </>
  );
};

export default UsersPage;
